import { IsArray, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IAdapterCalendarDay } from "./adapter-calendar-day.interface";
import { AdapterCalendarShift } from "./adapter-calendar-shift.dto";

export class AdapterCalendarDay implements IAdapterCalendarDay {
  //
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => AdapterCalendarShift)
  shifts: AdapterCalendarShift[];
}
